export const formatLargeNumber = (num) => {
  if (isNaN(num) || num === null) return "Invalid number";
  if (num === 0) return "0";

  const isNegative = num < 0;
  num = Math.abs(num);

  const formatter = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: num < 1 ? 6 : 2,
    minimumFractionDigits: num >= 1 ? 2 : 0,
  });

  const formatted = formatter.format(num);
  return isNegative ? `-${formatted}` : formatted;
};
